import { useMemo, type PropsWithChildren } from 'react';
import { BrandCardImage } from './BrandCardImage';
import { BrandCardContent } from './BrandCardContent';

type BrandCardProps = PropsWithChildren;

export const BrandCard = ( { children }: BrandCardProps ) => {

  const Components = useMemo( () => {
    return Array.isArray( children ) ? children : [ children ];
  }, [ children ] );

  const Image = Components.find( c => c?.type?.displayName === BrandCardImage.displayName );
  const Content = Components.find( c => c?.type?.displayName === BrandCardContent.displayName );

  return (
    <div className={ 'group flex flex-col gap-2.5' }>
      { Image }
      { Content }
    </div>
  )
}
BrandCard.displayName = 'BrandCard';
